
export default [
  {
    "title": "The Battle of the Opt-In Methods",
    "description": "Francis and other Deliverability folks in the industry sit down and chat about the challenges they see with the adoption of different Opt-In methods.",
    "date": new Date("2021-02-23T00:00:00.000Z"),
    "type": "Blog Posts",
    "imgSrc": "https://blog.kickbox.com/content/images/2021/02/Battle-Opt-In-Method.png",
    "imgHeight": 384,
    "imgWidth": 762,
    "url": "https://blog.kickbox.com/the-battle-of-the-opt-in-methods",
    "content": "",
    "_meta": {
      "filePath": "1.mdx",
      "fileName": "1.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "1"
    },
    "html": ""
  },
  {
    "title": "Why Aren’t My Emails Working? Deliverability 101",
    "description": "Francis sits down with Vira and Alissa from Flowium and chats about Deliverability.",
    "date": new Date("2020-11-17T00:00:00.000Z"),
    "type": "Podcasts",
    "imgSrc": "https://flowium.com/wp-content/uploads/2020/11/Desktop-Francis-Baker.png",
    "imgHeight": 384,
    "imgWidth": 762,
    "url": "https://flowium.com/podcasts/why-arent-my-emails-working-everything-you-need-to-know-about-email-deliverability-with-francis-baker-klaviyo/",
    "content": "",
    "_meta": {
      "filePath": "2.mdx",
      "fileName": "2.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "2"
    },
    "html": ""
  },
  {
    "title": "Klaviyo Data Science Podcast EP 40 | Platform Abuse and Misuse",
    "description": "Francis and a few other Klaviyo's on the Klaviyo Data Science podcast discuss Platform Abuse, the challenges at scale, the impact to the customer experience and more.",
    "date": new Date("2023-10-13T00:00:00.000Z"),
    "type": "Podcasts",
    "imgSrc": "https://miro.medium.com/v2/resize:fit:720/format:webp/1*eP6N63Vxo91ARyv8l5hMRQ.png",
    "imgHeight": 384,
    "imgWidth": 762,
    "url": "https://medium.com/klaviyo-data-science/klaviyo-data-science-podcast-ep-40-platform-abuse-and-misuse-53231736d888",
    "content": "",
    "_meta": {
      "filePath": "3.mdx",
      "fileName": "3.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "3"
    },
    "html": ""
  }
]